export default "__VITE_ASSET__C_l69rej__"